import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-dropdown-no-results" }
const _hoisted_2 = { class: "app-dropdown-option-link" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon",
  width: "12",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#plus" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_dropdown_selected = _resolveComponent("app-dropdown-selected")!
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_dropdown_option = _resolveComponent("app-dropdown-option")!
  const _component_vue_tippy = _resolveComponent("vue-tippy")!
  const _component_app_block_ui = _resolveComponent("app-block-ui")!
  const _directive_app_tippy_visible = _resolveDirective("app-tippy-visible")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps({
    class: ["app-dropdown", { 'app-dropdown-theme-default': _ctx.defaultTheme }]
  }, _ctx.$attrs), [
    _createVNode(_component_app_block_ui, { blocked: _ctx.blocked }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_vue_tippy, _mergeProps(_ctx.tippyProps, {
          interactive: "",
          placement: _ctx.placement,
          theme: _ctx.tippyTheme,
          offset: [0, 0],
          animation: _ctx.animation,
          arrow: _ctx.arrow,
          trigger: "manual",
          "hide-on-click": false,
          "max-width": "none",
          tag: "div",
          class: ["app-dropdown-selected", { 'selected-box-mode': _ctx.showSelectedAsBox }],
          "content-tag": "ul",
          "content-class": "app-dropdown-items",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disabled ? null : _ctx.isOpen = !_ctx.isOpen)),
          onKeydown: [
            _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.getNextOrPrev('next')), ["prevent"]), ["down"])),
            _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.getNextOrPrev('prev')), ["prevent"]), ["up"]))
          ],
          sticky: true
        }), {
          content: _withCtx(() => [
            (_ctx.searchable)
              ? _renderSlot(_ctx.$slots, "search", _normalizeProps(_mergeProps({ key: 0 }, _ctx.slotSearchProps)), () => [
                  _createVNode(_component_app_dropdown_search, _normalizeProps(_guardReactiveProps(_ctx.slotSearchProps)), null, 16)
                ])
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass({ 'searchable-scroll-panel': _ctx.searchable })
            }, [
              _renderSlot(_ctx.$slots, "dropdown-items", {}, () => [
                (_ctx.searchable && !_ctx.finalViewOptions.length)
                  ? _renderSlot(_ctx.$slots, "no-results", { key: 0 }, () => [
                      _createElementVNode("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "no-results-text", {}, () => [
                          _createVNode(_component_i18n_t, { keypath: "dropdown.noResults" })
                        ])
                      ])
                    ])
                  : _createCommentVNode("", true),
                (_ctx.firstOption?.show)
                  ? _renderSlot(_ctx.$slots, "option", { key: 1 }, () => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_router_link, {
                          to: _ctx.firstOption?.url
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createTextVNode(" " + _toDisplayString(_ctx.firstOption?.title), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finalViewOptions, (data, index) => {
                  return _renderSlot(_ctx.$slots, "option", _normalizeProps(_mergeProps({
                    key: _ctx.trackBy(data.details.option, index)
                  }, _ctx.slotOptionProps(data.value, data.details))), () => [
                    _createVNode(_component_app_dropdown_option, _mergeProps({ fontSize: _ctx.fontSize }, _ctx.slotOptionProps(data.value, data.details)), null, 16, ["fontSize"])
                  ])
                }), 128))
              ])
            ], 2)
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "selected", _normalizeProps(_guardReactiveProps(_ctx.slotSelectedProps)), () => [
              _createVNode(_component_app_dropdown_selected, _mergeProps({
                fontSize: _ctx.fontSize,
                tabindex: _ctx.tabindex
              }, _ctx.slotSelectedProps, {
                onKeyup: [
                  _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.isOpen = !_ctx.isOpen), ["enter"])),
                  _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.isOpen = !_ctx.isOpen), ["space"]))
                ]
              }), null, 16, ["fontSize", "tabindex"])
            ])
          ]),
          _: 3
        }, 16, ["placement", "theme", "animation", "arrow", "class"])), [
          [_directive_app_tippy_visible, _ctx.isOpen]
        ])
      ]),
      _: 3
    }, 8, ["blocked"])
  ], 16)), [
    [_directive_click_outside, () => (_ctx.isOpen = false)]
  ])
}